import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BrandM } from '@sorare/core/src/atoms/typography';

import { TutorialBezel } from '../../TutorialBezel';
import streak from '../assets/streak.png';

const Img = styled.img`
  width: 100%;
  height: auto;
`;

export const StartStreak = () => {
  return (
    <TutorialBezel color="var(--c-rewards-blue)">
      <Vertical gap={5} center>
        <Vertical center className="text-center">
          <BrandM>
            <FormattedMessage
              id="StartStreak.title"
              defaultMessage="Start a Streak"
            />
          </BrandM>
          <BodyM color="var(--c-nd-600)">
            <FormattedMessage
              id="StartStreak.description"
              defaultMessage="Higher streaks, higher rewards!"
            />
          </BodyM>
        </Vertical>
        <Img src={streak} alt="" />
      </Vertical>
    </TutorialBezel>
  );
};
